import { gql } from "@apollo/client"

export const GET_JOB_LISTING_QUERY = gql`
    query Records($filter: FilterFindManyJobInput) {
        jobsList(filter: $filter) {
            records {
                _id
                serial
                jobReference
                billable {
                    _id
                    account
                    company
                }
                destination {
                    _id
                    account
                    company
                }
                items {
                    name
                    code
                    quantity
                    unit
                    pricePerItem
                    kgPerUnit
                    quantityLoaded
                    quantityUnloaded
                    _id
                    itemId
                }
                origin {
                    account
                    company
                    _id
                }
                originAddress {
                    address
                    geofence {
                        _id
                        geometry
                        properties {
                            entity
                            entityId
                            name
                            type
                        }
                    }
                    gps
                    _id
                }
                destination {
                    account
                    company
                    _id
                }
                destinationAddress {
                    address
                    geofence {
                        _id
                        geometry
                        properties {
                            entity
                            entityId
                            name
                            type
                        }
                    }
                    gps
                    _id
                }
                jobStatus
                groupId
                customFields {
                    customFieldGroup {
                        _id
                        name
                    }
                    customFieldTemplateId
                    name
                    type
                    value
                    systemVisibility
                    driverVisibility
                    requiredStage
                    enumeratedValues
                }
            }
        }
    }
`

export const GET_JOB_QUERY = gql`
    query Job($id: MongoID!) {
        job(_id: $id) {
            jobReference
            jobDate
            jobType
            groupId
            items {
                name
                code
                quantity
                unit
                pricePerItem
                kgPerUnit
                quantityLoaded
                quantityUnloaded
                _id
                itemId
            }

            _id
            jobStatus
            origin {
                account
                company
                _id
            }
            originAddress {
                address
                gps
                _id
            }
            billable {
                account
                company
                _id
            }
            destination {
                account
                company
                _id
            }
            destinationAddress {
                address
                gps
                _id
            }
            assignedShift {
                shiftId
                vehicle
                driver
                shiftTemplate
                shiftStart
                shiftEnd
            }
        }
    }
`

export const GET_DOCUMENT_TYPES = gql`
    query DocumentTypesList(
        $filter: FilterFindManyDocumentTypeInput
        $sort: SortFindManyDocumentTypeInput
        $limit: Int
    ) {
        documentTypesList(filter: $filter, sort: $sort, limit: $limit) {
            records {
                _id
                name
                description
            }
        }
    }
`
